<template>
  <v-dialog
    v-model="dialog"
    persistent
    min-width="auto !important"
    width="fit-content !important"
    class="wrapper-1 bg-white pos-relative"
  >
    <v-card>
      <v-card-title class="fs-1-5r bg-grey mb-2">
        SFTP Access Details
      </v-card-title>
      <!--  -->
      <v-card-text class="font-size-16 px-2 pb-2"> Protocol: SFTP </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2"> Host: {{ computedHost }} </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2"> Port: 22 </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2">
        Username: {{ computedUsername }}
      </v-card-text>
      <v-card-text class="font-size-16 px-2 pb-2">
        Password: {{ userName }} Yazam MFT password
      </v-card-text>
      <v-divider></v-divider>
      <div class="d-flex justify-space-between pa-4">
        <Button
          :clickAction="sendEmailClicked"
          width="fit-content"
          btnType="blue"
          class="mr-4"
          text="Send Email"
        />
        <Button
          :clickAction="closeDialog"
          width="fit-content"
          btnType="grey"
          text="Cancel"
        />
      </div>
    </v-card>
    <InsertEmailDialogForCasual
      v-if="isShowInsertDialog"
      :closeDialog="() => (isShowInsertDialog = false)"
      :sftpUsername="computedUsername"
      :isTarget="true"
      :groupName="sender"
    />
  </v-dialog>
</template>

<script>
import Button from '@/components/BaseComponents/Button/Button.vue'
import InsertEmailDialogForCasual from '@/components/BaseComponents/CasualCommonComponents/InsertEmailDialogForCasual.vue'

export default {
  name: 'SftpDetailsDialogForCasualSender',
  data() {
    return {
      isNone: true,
      dialog: true,
      sender: null,
      isShowInsertDialog: false,
    }
  },

  props: {
    casualUsers: Array,
    userEmail: String,
    userName: String,
    closeDialog: Function,
  },
  components: { Button, InsertEmailDialogForCasual },
  // watch: {
  //   isNone: {
  //       handler: function (n) {
  //         if (n){
  //           this.sender = null
  //         }
  //         else this.session.selectedUsers = []
  //       },
  //     },
  // },
  computed: {
    computedHost() {
      return window.location.host
    },
    computedUsername() {
      return `${this.userEmail}\\Guest Accounts${
        this.sender ? '\\' + this.sender.email : ''
      }`
    },
  },
  methods: {
    sendEmailClicked() {
      this.isShowInsertDialog = true
    },
    noneClicked() {
      this.sender = null
      this.$refs.autocomplete.blur()
    },
  },
}
</script>

<style scoped>
.select-senders {
  padding: 0px 8px 7px 0px;
  display: flex;
  align-items: center;
}
.select-all-wrapper {
  display: flex;
  align-items: center;
}

.select-all-wrapper >>> .v-input {
  margin-top: 0;
}
</style>
